module.exports = __webpack_public_path__ + "media/step-1.ad43e8cd.mp4";